import React, { useEffect, useState, Fragment, useRef } from 'react';
// import useSetState from "@danedavid/usesetstate";
// import S3 from "react-aws-s3";
import { Field } from 'formik';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components'
import CloseIcon from '@material-ui/icons/Close';
import AlertModal from 'web/components/AlertModal';
import Tooltip from "@material-ui/core/Tooltip";

import {
  uploadSpecification,
} from 'redux/actions/postLoad';
import {
  taxExemptionApi
} from 'redux/actions/profile'

export default ({
  name,
  props,
  forwardedRef,
  clickHandler,
  acceptFiles,
  attachOption,
  errorMsg,
  setField = true,
  fileArr,
  btnTxt,
  imageLoadCallBack,
  callBackFun,
  onChange
}) => {

  let imgArr = []
  const [fileState, updateFileState] = useState({
    files: '0',
    filesArr: imgArr
  });
  const {
    setFieldValue,
  } = props;

  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');

  const [sameFileState, setSameFileState] = useState(false);
  const [upLoadArr, setUpLoadArr] = useState();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContent = useSelector(state => state.language.languageContent)
  const [pageLanguageContents, setPageLanguageContents] = useState([])

  useEffect(() => {
  }, [currentLanguage]);

  useEffect(() => {
    if (languageContent !== undefined && languageContent.length !== 0) setPageLanguageContents(languageContent.H8_Nav_Profile_Page)
  }, [languageContent])

  useEffect(() => {
    if (fileState.filesArr.length !== 0) {
      if (name === "fileUpload") {
        imageLoadCallBack(fileState.filesArr)
      }
      if (name === "uploadSpecificationImg") {
        imageLoadCallBack(fileState.filesArr)
      }
      if (name === "uploadSpecificationImgLoad") {
        imageLoadCallBack(fileState.filesArr)
      }
      if (name === "uploadPalletInventoryImg") {
        imageLoadCallBack(fileState.filesArr)
      }
      if (name === "uploadSpecification") {
        callBackFun(fileState.filesArr)
      }
    }
  });

  const uploadImageApi = async (file, fileArr, action) => {

    let formData = new FormData();
    for (let i = 0; i < fileArr.length; i++) {
      formData.append("uploadSpecification", fileArr[i]);
    }

    let response = await dispatch(uploadSpecification(formData, token));

    if (response.status === 'SUCCESS') {
      if (action === "Delete") {
        updateFileState({ ...fileState, filesArr: file });
      } else if (action === "lastItem") {
      }
      else {
        callBackFun(response.payload)
        for (let i = 0; i < fileArr.length; i++) {
          if (fileArr.length !== 3) {
            updateFileState({
              ...fileState, filesArr: [...fileState.filesArr, file]
            })
          }
          let timmer = setTimeout(function () {
            clearTimeout(timmer);
            if (i === fileArr.length - 1) {
              if (fileArr.length == 2) {
                fileArr.push(file)
                uploadImageApi(file, fileState.filesArr)
              }
            }
          }, 1000);
        }
      }
      setUpLoadArr(response.payload)
      callBackFun(response.payload)
    } else {
      if (response.message === "Unauthorized (Invalid token)") {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }

  const exemptionImageApi = async (file, fileArr, action) => {
    callBackFun(file)
  }

  let arr = []

  const handleChange = async (name, e, setFieldValue, setFieldError) => {
    e.preventDefault();
    setSameFileState(false)
    const fileTypes = acceptFiles.split(',');
    let files = e.target.files;
    var specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let uploadFileName = file?.name
      let uploadFileNameFirstString = uploadFileName?.substring(0, 1)
      if (name === "uploadPalletInventoryImg" && uploadFileNameFirstString && specialChar.test(uploadFileNameFirstString)) {
        setModalContent('Please upload an image with valid name.');
        setModalLink('');
        toggleModal();
        return false;
      } else if (file && fileTypes.includes(file.type)) {
        if (file.size > 5242880) {
          setModalContent('Please upload a file smaller than 5MB.');
          setModalLink('');
          toggleModal();
          return false;
        } else {
          if (name === "taxExemption" || name === "drivingLicenseDoc" || name === "editTaxExemption" || name === "bolDocument") {
            fileArr.push(file)
            if (fileState.filesArr.length !== 0) {
              if (name !== "bolDocument") {
                setFieldError(name, 'Maximum 1 file can be uploaded (Should not exceed 5 MB)');
                setFieldValue(name, fileState.filesArr)
              }

            } else {
              // setFieldError(name, '')
              setFieldValue(name, file)
              updateFileState({
                ...fileState, filesArr: [file]
              })

              exemptionImageApi(file, file)
            }

          } else {
            fileArr.push(file)
            for (let i = 0; i < fileState.filesArr.length; i++) {
              if (fileState.filesArr[i].name === file.name) {
                setSameFileState(true)
                return false;
              }
            }

            if (fileState.filesArr.length <= 2 && name !== 'uploadPalletInventoryImg') {
              updateFileState({
                ...fileState, filesArr: [...fileState.filesArr, file]
              })
            } else if (fileState.filesArr.length <= 0 && name === 'uploadPalletInventoryImg') {
              updateFileState({
                ...fileState, filesArr: [...fileState.filesArr, file]
              })
            }

           
          }

          if (name === "uploadSpecificationImg" || name === "uploadSpecificationImgLoad") {
          }
        }
        if (!attachOption) setFieldValue(name, null);
        // setFieldError(name, '');
      } else {
        setFieldError(name, errorMsg);
        clickHandler(null);
      }
    }
  };
  const singleFile = (form, meta) => {
    return (
      <label className="uploadPhoto" htmlFor="file">
        {fileState.filesArr.length !== 0 &&
          fileState.filesArr.map((file, index) => (
            <>
              {index === 0 && (
                <div key={index}>
                  <Tooltip
                    placement="top"
                    arrow
                    title={file.name}
                    enterTouchDelay={0}
                  >
                    <p>{file.name}</p>
                  </Tooltip>

                  <CloseIcon
                    onClick={() => {
                      fileArr.splice(index, 1);
                      fileState.filesArr.splice(index, 1);
                      updateFileState({
                        ...fileState,
                        filesArr: fileState.filesArr,
                      });

                      if (name === "bolDocument" || name === "editTaxExemption" || name === "taxExemption" || name === "drivingLicenseDoc") {
                        fileState.filesArr.splice(index, index)
                        if (fileState.filesArr.length === 0) {
                          form.setFieldError(name, '');
                        }
                        callBackFun(upLoadArr && upLoadArr.splice(index, index))
                      }
                    }}
                  />
                </div>
              )}
            </>
          ))}
        {name !== "bolDocument" &&
          meta.error && (
            <p name={name + "Error"} className="error-message-multiple">
              {meta.error}
            </p>
          )
        }
      </label>
    );
  }
  const attachFiles = (form, meta) => {
    return <label className="uploadPhoto" htmlFor="file">
      {fileState.filesArr.length !== 0 && (
        fileState.filesArr.map((file, index) => (
          <div key={index}>
            {file.name}
            <CloseIcon onClick={() => {
              let filterData = fileState.filesArr.filter((item, i) => i !== index)
              fileArr.splice(index, index)
              form.setFieldValue(name, filterData);
              fileState.filesArr.splice(index, index)
              if (name === "uploadSpecificationImg" || name === "uploadSpecificationImgLoad" || name === "uploadPalletInventoryImg") {
                updateFileState({ ...fileState, filesArr: filterData });
                callBackFun(upLoadArr && upLoadArr.splice(index, index))
              } else if (name === "taxExemption" || name === "drivingLicenseDoc" || name === "editTaxExemption" || name === "bolDocument") {
                updateFileState({ ...fileState, filesArr: filterData });
                if (filterData.length === 1 && upLoadArr.length !== 0) {
                  upLoadArr.splice(index, index)
                  exemptionImageApi(filterData[0], filterData, "lastItem")
                } else {
                  callBackFun(upLoadArr && upLoadArr.splice(index, index))
                }
              }
              else {
                updateFileState({ ...fileState, filesArr: filterData });
                if (name === "fileUpload") {
                  imageLoadCallBack(filterData)
                }
                if (name === "uploadSpecification") {
                  callBackFun(filterData)
                }
              }
            }} />
          </div>
        ))
      )}
      {meta.error && <p name={name + 'Error'} className="error-message-multiple">{meta.error}</p>}
    </label>
  }
  return (
    <>
      <Field name={name}>
        {({ form, meta }) => (
          <Fragment>
            <InputWrapper className='multiple-file-input'>
              <input
                id={name}
                ref={forwardedRef}
                type="file"
                className="custom-file-input"
                accept={acceptFiles}
                multiple={false}
                onClick={e => (e.target.value = '')}
                onChange={e =>
                  handleChange(name, e, form.setFieldValue, form.setFieldError)
                }
                aria-label="file"
              />
              {name === "taxExemption" || name === "editTaxExemption" ?
                <>
                  {name === "fileUpload" || name === "taxExemption" || name === "editTaxExemption" || name === "bolDocument" || name === "creditRef" ? name === "bolDocument" ? <span className='text'>Click Here</span> : <span className='text'>{btnTxt ? btnTxt : 'Upload Exempt Form'}</span> : name === "uploadSpecificationImgLoad" ? <span className='text'>Upload Specification</span> : <span className='text'>Upload Specification*</span>}
                </>
                :
                <>
                  {name === "fileUpload" || name === "bolDocument" || name === "creditRef" ? name === "bolDocument" ? <span className='text'>Upload BOL/POD</span>
                    : <span className='text'>{btnTxt ? btnTxt : 'Upload Images/Documents'}</span> : name === "uploadSpecificationImgLoad" ? <span className='text'>Upload Specification</span>
                      : name === 'drivingLicenseDoc' ? <span className='text'>Upload Driver's License</span>
                        : <span className='text'>Upload Specification*</span>}
                </>
              }
              {name === 'uploadPalletInventoryImg' &&
                <>
                  <span className='text'>Upload Product Images</span>
                </>
              }
              {name === "taxExemption" || name === "drivingLicenseDoc" || name === "editTaxExemption" || name === "bolDocument" ? singleFile(form, meta) : attachFiles(form, meta)}
            </InputWrapper>
          </Fragment>
        )}
      </Field>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
};

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  .text {
        background: linear-gradient(to bottom,#61b01f 0%,#27911b 100%);
    color: #fff;
    padding: 9px 32px;
    font-family: 'latomedium';
    border-radius: 5px;
    position: absolute;
    left: auto;
    top: 0;
    font-size: 14px;
    cursor: pointer;
  }
  .custom-file-input {
    opacity: 0 !important;
    max-width: 200px;
    cursor: pointer;
  }
`;